import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { VirtualCashModelsDto } from "../../models/virtual-cash.models";
import { NotificationService } from "../../../../services/notification.service";
import { ContextMenuService } from "../../../../services/context-menu.service";

@Component({
  selector: "app-virtual-pos-context-menu",
  templateUrl: "./virtual-pos-context-menu.component.html",
  styleUrls: ["./virtual-pos-context-menu.component.scss"],
})
export class VirtualPosContextMenuComponent {
  @Input() item!: VirtualCashModelsDto;

  @Output() unlockedEvent: EventEmitter<VirtualCashModelsDto> = new EventEmitter<VirtualCashModelsDto>();
  @Output() blockedEvent: EventEmitter<VirtualCashModelsDto> = new EventEmitter<VirtualCashModelsDto>();
  @Output() editEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() commissionEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() deleteEvent: EventEmitter<number> = new EventEmitter<number>();

  constructor(private contextMenuService: ContextMenuService) {}

  unlocked() {
    this.unlockedEvent.emit(this.item);
    this.contextMenuService.statusMenu$.next(false);
  }

  blocked() {
    this.blockedEvent.emit(this.item);
    this.contextMenuService.statusMenu$.next(false);
  }

  edit() {
    this.editEvent.emit(this.item.id);
    this.contextMenuService.statusMenu$.next(false);
  }

  commission() {
    this.commissionEvent.emit(this.item.id);
    this.contextMenuService.statusMenu$.next(false);
  }

  delete() {
    this.deleteEvent.emit(this.item.id);
    this.contextMenuService.statusMenu$.next(false);
  }
}
